import React from "react";
import LogoImg from "../../../assets/images/kiashaa-logo.png";
const Logo = (props) => {
  return (
    <>
      <img src={LogoImg} alt="Logo" width={"120"} />
    </>
  );
};

export default Logo;
